// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__9QBWL","footer":"ModalFilter_footer__37d5W"};